import React, { useState, createContext, JSX } from 'react';
import { AxiosError } from 'axios';

import {
  TDownloadsContextType,
  IOfflineDownloadListResponse,
} from '../models/downloads';

interface IDownloadsProvider {
  children: JSX.Element;
}

export const DownloadContext = createContext<TDownloadsContextType | undefined>(
  undefined,
);

const DownloadProvider = ({ children }: IDownloadsProvider) => {
  const [downloadsData, setDownloadsData] =
    useState<IOfflineDownloadListResponse>();
  const [downloadsError, setDownloadsError] = useState<AxiosError>();
  const [downloadsLoaded, setDownloadsLoaded] = useState(false);

  return (
    <DownloadContext.Provider
      value={{
        downloadsData,
        downloadsError,
        downloadsLoaded,
        setDownloadsData,
        setDownloadsError,
        setDownloadsLoaded,
      }}
    >
      {children}
    </DownloadContext.Provider>
  );
};

export default DownloadProvider;
